import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';
import OperatingSystemIcons from './operating_system_icons';
import * as I18n from 'i18n-js';

class DropdownVariant extends React.Component {
  onClick() {
    this.props.onChooseVariant(this.props.variant);
  }

  downloadSize() {
    if (this.props.variant.fileSize) {
      return <span className="pull-right">{this.props.variant.fileSize}</span>;
    }

    return false;
  }

  render() {
    return (
      <div
        className="dropdown-option mini-module bd-1 bd--offwhite bd-rounded"
        onClick={() => this.onClick()}
      >
        <div className="small strong">
          <i
            className={
              classNames(
                'fa',
                'mr-half',
                `fa-${OperatingSystemIcons[this.props.variant.operatingSystem.value_uuid]}`,
              )
            }
          />
          {this.props.variant.operatingSystem.value_name}
        </div>
        <div className="fine-print">
          {this.props.variant.fileTypeNames.join(I18n.t('js.listSeparator'))}
          {this.downloadSize()}
        </div>
      </div>
    );
  }
}

DropdownVariant.propTypes = {
  variant: PropTypes.object.isRequired,
  onChooseVariant: PropTypes.func.isRequired,
};

export default DropdownVariant;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/digital_listings/dropdown_variant.jsx